import React, { SVGProps } from 'react'

export const MaskLastPhotoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={262}
    height={268}
    fill="none"
    {...props}
  >
    <path
      fill="#9066FF"
      fillOpacity={0.32}
      d="M16.56 188.14c33.697 90.788 147.519 76.22 189.545 49.649 88.444-58.679 70.202-217.513-49.141-226.97C37.62 1.362-25.561 74.654 16.56 188.14Z"
    />
    <path
      fill="#9066FF"
      fillOpacity={0.32}
      d="M27.336 182.404c30.538 80.73 135.446 66.536 171.777 44.149C279.7 169.79 262.735 33.137 154.578 24.728 46.422 16.318-10.837 81.491 27.336 182.404Z"
    />
    <path
      stroke="#CEBBFF"
      d="M.5 171c1.746 10.459 10.19 36.702 30 58"
      opacity={0.4}
    />
    <path
      stroke="#CEBBFF"
      strokeLinecap="round"
      d="M41.5 26c15.618-11.545 63.683-32.202 131-22.466M62.5 254c18.351 9.81 70.843 23.544 134 0"
      opacity={0.4}
    />
  </svg>
)
